import { createI18n } from 'vue-i18n'
import ko from './locales/ko.json'
import en from './locales/en.json'
import zh from './locales/zh.json'

const saved = localStorage.getItem('locale')
// const browser = (navigator.language || 'ko').toLowerCase()

// function detectLocale() {
//   if (saved) return saved
//   if (browser.startsWith('zh')) return 'zh'
//   if (browser.startsWith('en')) return 'en'
//   return 'ko'
// }

export const SUPPORT_LOCALES = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' }
  // { code: 'zh', label: '中文' }
]

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: saved || 'ko',
  fallbackLocale: 'ko',
  messages: { ko, en, zh }
})

export function setLocale(locale) {
  localStorage.setItem('locale', locale)
  document.documentElement.lang = locale
  location.reload()
}